import { render, staticRenderFns } from "./AddGaugeWidget.vue?vue&type=template&id=63dc1df7"
import script from "./AddGaugeWidget.vue?vue&type=script&lang=js"
export * from "./AddGaugeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports